import { useCallback, useRef } from 'react';

import { EnumOpenDialog } from '../stores/ui/types';
import { useStores } from '../stores/useStores';

export function useMissedCountrySettings() {
  const {
    uiStore,
    userStore: { profile },
  } = useStores();

  const isCountrySetAlreadyShowed = useRef(false);

  const checkCountrySetMissed = useCallback(() => {
    if (profile && !profile.isCountrySetByUser && !isCountrySetAlreadyShowed.current) {
      isCountrySetAlreadyShowed.current = true;
      return true;
    }
    return false;
  }, [profile]);

  const showCountrySetDialog = useCallback(() => {
    uiStore.setOpenDialog({ dialog: EnumOpenDialog.isOpenChooseCountryDialog });
  }, [uiStore]);

  return { checkCountrySetMissed, showCountrySetDialog };
}
